import { render, staticRenderFns } from "./backgroundStyle.vue?vue&type=template&id=3bb98f43&scoped=true"
import script from "./backgroundStyle.vue?vue&type=script&lang=js"
export * from "./backgroundStyle.vue?vue&type=script&lang=js"
import style0 from "./backgroundStyle.vue?vue&type=style&index=0&id=3bb98f43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb98f43",
  null
  
)

export default component.exports